module.exports = __webpack_public_path__ + "img/Path 14@3x.4d4e5906.png";